/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import axios from 'axios'

import { API } from '../api/api'
import { fetch, post, put, setAxiosBase } from '../api/httpClient'
import localStorageService from '../api/localStorageService'
import { MESSAGE_SEVERITIES, ROUTES, UsPhoneCode } from '../helpers/constants'
import { selectApp, selectMetaData, selectSchool, selectUser } from '../helpers/selectors'
import {
  checkRegisterationState,
  getDashAddedPhone,
  getSchoolUrl,
  isEmpty,
  isUnauthRoute,
  set,
} from '../helpers/utils'
import ActionTypes from './actionTypes'
import { introspectAction, messageAction, schoolAction, uiStateAction } from './app.action'
import { fetchMetadata, userByEmailCall } from './user.action'

export const mapAuth = (auth) => ({
  accessToken: auth.access_token,
  refreshToken: auth.refresh_token,
  tokenType: auth.token_type,
  accountId: auth.accountId,
  userName: auth.userName,
})

export const loginAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.LOGIN,
    data,
  })
export const forgotAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.FORGOTPASSWORD,
    data,
  })

export const accountActionForGuestCheckout =
  (params, successCallback, failureCallback) => async (dispatch) => {
    try {
      const { district, school, guest_customer } = params
      let url = API.CORE.SLUG
      if (district) {
        url += `/district/${district}`
      }
      if (school) {
        url += `/school/${school}`
      }
      const { data } = await fetch(url)
      const mappedAuth = {
        accountId: data.sch_tenant_id || data?.sch_district?.dst_tenant_id,
        realmName: data.sch_school_public_id || data?.sch_district?.dst_district_public_id,
      }
      setAxiosBase({
        'X-CW-Tenant-Id': mappedAuth.accountId,
        'realm-name': mappedAuth.realmName,
      })
      modifySchoolItem(data)
      dispatch(schoolAction(data))
      await dispatch(fetchMetadata())
      await dispatch(introspectCall(guest_customer))
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }
export const accountAction =
  (params, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const { district, school, guest_customer } = params
      let url = API.CORE.SLUG
      if (district) {
        url += `/district/${district}`
      }
      if (school) {
        url += `/school/${school}`
      }
      const { data } = await fetch(url)
      const mappedAuth = {
        accountId: data.sch_tenant_id || data?.sch_district?.dst_tenant_id,
        realmName: data.sch_school_public_id || data?.sch_district?.dst_district_public_id,
      }
      setAxiosBase({
        'X-CW-Tenant-Id': mappedAuth.accountId,
        'realm-name': mappedAuth.realmName,
      })
      modifySchoolItem(data)
      dispatch(schoolAction(data))
      await dispatch(fetchMetadata())
      await dispatch(introspectCall(guest_customer))
      dispatch(
        userByEmailCall((user) => {
          dispatch(loginAction({ isLoggedIn: true }))
          const metadata = selectMetaData(getState())
          const registerationState = checkRegisterationState(user, metadata)
          if (!isEmpty(registerationState) && user.isStudent) {
            dispatch(
              uiStateAction({
                registerationState: { ...registerationState, complete: false },
              })
            )
          } else if (isEmpty(registerationState) && user.isStudent) {
            dispatch(uiStateAction({ registerationState: { complete: true } }))
          }
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const introspectCall =
  (is_guest, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const { loginURL } = selectApp(state)
      const { sch_school_public_id, sch_tenant_id } = selectSchool(state)
      const url = `${loginURL}/${sch_tenant_id}/${sch_school_public_id}/basic/introspect/self`
      const { data } = await fetch(url)
      set(
        data,
        'session_metadata._adminInitializedSession',
        (data?.session_metadata?._adminInitializedSession || 'false') === 'true'
      )
      set(
        data,
        'session_metadata._parentInitializedSession',
        (data?.session_metadata?._parentInitializedSession || 'false') === 'true'
      )
      dispatch(introspectAction(data))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
      if (error.response.status === 401 && !isUnauthRoute() && !is_guest) {
        const params = localStorageService.getDistrictSchool()
        dispatch(redirectToLogin(params))
      }
    }
  }

export const redirectToLogin = (params, id) => (_, getState) => {
  localStorageService.clearDistrictSchool()
  const state = getState()
  const app = selectApp(state)
  const school = selectSchool(state)
  const redirectBase =
    process.env.NODE_ENV === 'production' ? app.redirectBase : 'https://local.stpldevs.com:4001'
  const relativePath = id
    ? getSchoolUrl({
        ...params,
        to: `${ROUTES.LOGIN}/auth?pid=${id}`,
      })
    : getSchoolUrl({
        ...params,
        to: `${ROUTES.LOGIN}/auth`,
      })

  const loginUrl = `${app.loginURL}/${school.sch_tenant_id}/${school.sch_school_public_id}/basic?redirect_url=${redirectBase}${relativePath}`
  window.location.href = loginUrl
}

export const redirectToAdminLogin = () => (_, getState) => {
  localStorageService.clearDistrictSchool()
  const state = getState()
  const app = selectApp(state)
  const { sch_tenant_id } = selectSchool(state)
  const loginUrl = sch_tenant_id
    ? `${app.adminAuthURL}/authgateway/api/authenticate?client_id=${sch_tenant_id}&redirect_uri=${app.adminURL}${ROUTES.LOGIN}`
    : `${app.adminURL}${ROUTES.LOGIN}`
  window.location.href = loginUrl
}

export const redirectToRootAdminLogin = () => (_, getState) => {
  localStorageService.clearDistrictSchool()
  const state = getState()
  const app = selectApp(state)
  const loginUrl = `${app.adminURL}${ROUTES.LOGIN}`
  window.location.href = loginUrl
}

export const logout = (params) => (_, getState) => {
  localStorageService.clearDistrictSchool()
  localStorageService.clearAppState()
  const state = getState()
  const app = selectApp(state)
  const school = selectSchool(state)
  const redirectBase =
    process.env.NODE_ENV === 'production' ? app.redirectBase : 'https://local.stpldevs.com:4001'
  const relativePath = getSchoolUrl({
    ...params,
    to: `${ROUTES.LOGIN}`,
  })
  const logoutUrl = `${app.loginURL}/${school.sch_tenant_id}/${school.sch_school_public_id}/basic/logout?redirect_url=${redirectBase}${relativePath}`
  window.location.href = logoutUrl
}

export const verifyRecaptchaCall =
  (token, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const app = selectApp(state)
      const url = `${app.redirectBase}/verify/captcha`
      const { data } = await axios.post(url, { token })
      if (!data.success) {
        dispatch(
          messageAction({
            title: 'error:errorCaptchaVerification',
            subTitle: `error:error_${data['error-codes'][0]}`,
            severity: MESSAGE_SEVERITIES.ERROR,
          })
        )
      } else if (data.success && typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const updatePasswordCall =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    const apiPath = `${API.AUTH.CHANGEPASSWORD}`
    const updatedPayload = {
      currentPassword: payload.current_password,
      newPassword: payload.new_password,
    }
    try {
      await put(apiPath, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:passwordUpdated',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }
export const updateVerifyPasswordCall =
  (payload, successCallback, failureCallback) => async (dispatch, getState) => {
    const state = getState()
    const user = selectUser(state)
    const apiPath = `${API.AUTH.VERIFYPASSWORD}`
    const updatedPayload = {
      username: user.username,
      password: payload.password,
    }
    try {
      await post(apiPath, updatedPayload)
      // dispatch(
      //   messageAction({
      //     subTitle: 'message:passwordVerified',
      //     severity: MESSAGE_SEVERITIES.SUCCESS,
      //   })
      // )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

const modifySchoolItem = function (item) {
  if (isEmpty(item)) {
    return
  }

  const processPhone = (prefix, phone) =>
    phone ? (prefix === UsPhoneCode ? getDashAddedPhone(phone) : phone) : ''

  item.sch_phone = processPhone(item?.sch_phone_prefix, item?.sch_phone)

  if (item['sch_address']) {
    item['sch_address'].adr_phone = processPhone(
      item['sch_address']?.adr_phone_prefix,
      item['sch_address']?.adr_phone
    )
  }

  if (item.sch_district) {
    item.sch_district.dst_phone = processPhone(
      item?.sch_district?.dst_phone_prefix,
      item?.sch_district?.dst_phone
    )
  }
}
